//! Fathem Tracking - Add an id to the button in the backend then reference below
/*
const CHANGE_THIS_VARIABLE = document.querySelectorAll("[data-name = ADD DATA NAME]");
if (CHANGE_THIS_VARIABLE.length > 0) {
    CHANGE_THIS_VARIABLE[0].addEventListener("click", function () {
        fathom.trackEvent('EVENT_CODE');

    });
} */
const takeda = Array.from(document.querySelectorAll("[data-name = takeda_isth2024]")) ? Array.from(document.querySelectorAll("[data-name = takeda_isth2024]")) : [];;
if (takeda.length > 0) {
    takeda[0].addEventListener("click", function () {
        fathom.trackEvent('Takeda_ISTH_2024');
    });
}